import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import YotpoStars from 'src/components/YotpoStars'
import {
  Section,
  JumbotronImageContainer,
  ContentContainer,
  Headline,
  HeadlineMobile,
  Title,
  Text,
  TextMobile,
  Intro,
  IntroMobile,
  MobileContentContainer,
  CtaContainer,
  MobileTitle,
  CenteredMobile,
  BuyNowLink,
  TitleContainer,
} from './styles'
import { CAL_MAX_BUY_LINK, IN_UK, IN_AU, IS_FOREIGN_COUNTRY } from '../../utils/constants'

const CalMaxHero = () => {
  const { calendarHero, calendarHeroMobile, calendarHeroCa, calendarHeroMobileCa } =
    useStaticQuery(graphql`
      query calMaxHeroQuery {
        calendarHero: file(relativePath: { eq: "calmax/cal-max-hero.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        calendarHeroMobile: file(relativePath: { eq: "calmax/cal-max-hero-mobile.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        calendarHeroCa: file(relativePath: { eq: "calmax/cal-max-hero-ca.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        calendarHeroMobileCa: file(relativePath: { eq: "calmax/cal-max-hero-mobile-ca.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
      }
    `)

  const commonText = {
    intro: 'INTRODUCING CALENDAR MAX',
    mobileIntro: 'Introducing the Skylight Calendar Max',
    title:
      IN_UK || IN_AU
        ? 'Max<span>imise Your Family Time</span>'
        : 'Max<span>imize Your Family Time</span>',
    text: !IS_FOREIGN_COUNTRY
      ? 'Our best-selling smart calendar in an attention-grabbing 27" touchscreen display.'
      : 'The best-selling smart calendar is now available in a 27" touchscreen display.',
    cta: 'Buy Now',
    productId: '6863425175604',
  }
  const desktopImage = IS_FOREIGN_COUNTRY ? calendarHeroCa : calendarHero
  const mobileImage = IS_FOREIGN_COUNTRY ? calendarHeroMobileCa : calendarHeroMobile

  return (
    <>
      <Section>
        <JumbotronImageContainer>
          <GatsbyImage
            image={desktopImage.childImageSharp.gatsbyImageData}
            alt="Skylight Calendar Max displayed on wall"
            loading="eager"
          />
          <GatsbyImage
            image={mobileImage.childImageSharp.gatsbyImageData}
            alt="Skylight Calendar Max displayed on wall"
            loading="eager"
          />
        </JumbotronImageContainer>
        <TitleContainer>
          <MobileTitle dangerouslySetInnerHTML={{ __html: commonText.title }} />
        </TitleContainer>
        <ContentContainer>
          <Headline>
            <YotpoStars color="#000" textcolor="#444444" productId={commonText.productId} />
          </Headline>
          {IS_FOREIGN_COUNTRY && <Intro>{commonText.intro}</Intro>}
          <TitleContainer>
            <Title dangerouslySetInnerHTML={{ __html: commonText.title }} />
          </TitleContainer>
          <Text>{commonText.text}</Text>
          <CtaContainer>
            <CenteredMobile className="desktopCta">
              <BuyNowLink to={CAL_MAX_BUY_LINK}>{commonText.cta}</BuyNowLink>
            </CenteredMobile>
          </CtaContainer>
        </ContentContainer>
      </Section>
      <MobileContentContainer>
        <HeadlineMobile>
          <YotpoStars color="#000" textcolor="#444444" productId={commonText.productId} />
        </HeadlineMobile>
        {IS_FOREIGN_COUNTRY && <IntroMobile>{commonText.mobileIntro}</IntroMobile>}
        <TextMobile>{commonText.text}</TextMobile>
        <CenteredMobile>
          <BuyNowLink to={CAL_MAX_BUY_LINK}>{commonText.cta}</BuyNowLink>
        </CenteredMobile>
      </MobileContentContainer>
    </>
  )
}

export default CalMaxHero
